<template>
  <div>
    <!-- nav区 -->
    <!-- 返回栏 -->
    <div class="nav_back">
      <van-nav-bar title="资讯" left-arrow @click-left="back" />
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getListNews">
        <van-cell class="info_head">
          <span v-if="listNews[0]">{{ listNews[0].catName || '资讯' }}</span>
        </van-cell>
        <van-cell v-for="(item, index) in listNews" :key="index" style="line-height:14px" @click="toDetail(item.nId)">
          <div class="item">
            <div class="grid_left" @click="toDetail(item.nId)">{{ item.nTitle }}</div>
            <div class="grid_right">{{ item.nAddtime | getDate() }}</div>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navActive: 6,
      loading: false,
      finished: false,
      refreshing: false,
      params: {
        pageNo: 1,
        pageSize: 10,
        orders: 1,
        catid: '',
        keyword: '',
        isrecom: 0
      },
      listNews: [],
      total: 0
    }
  },
  created() {
    var query = this.$route.query
    if (query.catid) {
      this.params.catid = query.catid
    }
  },
  methods: {
    async getListNews() {
      var that = this
      if (this.refreshing) {
        this.listNews = []
        this.refreshing = false
      }
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/news/listNews', {
        params: this.params
      })
      if (data.success) {
        that.params.pageNo++
        if (data.data.page.rows.length > 0) {
          data.data.page.rows.forEach(item => {
            that.listNews.push(item)
          })
        }
        that.loading = false
        if (that.listNews.length >= data.data.page.recordCount) {
          that.finished = true
        }
        that.total = data.data.page.recordCount
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.brandText = ''
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        orders: 1,
        catid: '',
        keyword: '',
        isrecom: 0
      }
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.listNews = []
      this.getListNews()
    },
    toDetail(id) {
      console.log(123)
      this.$router.push({
        path: '/news-detail',
        query: {
          newsId: id
        }
      })
    },
    back() {
      this.brandBoxIsShow = false
      this.seriesPopupShow = false
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.nav_back {
  background-color: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 2;
}
.info_head {
  background-color: #f2f2f2;
}
.item {
  border-bottom: 1px solid #f2f3f4;
  padding: 10px 0;
  color: #888;
  line-height: 1.5;
  .grid_left:hover {
    cursor: pointer;
    color: #fe834b;
  }
  .grid_right {
    text-align: right;
  }
}
</style>
